/* NW soevnguide: linjen der giver en grund til at rulle ned til tilvalgene.
   Tilfoejet 31-08-2026.

   HVORFOR IKKE BARE SKAERE I INDHOLDET: tilvalgene laa 2,1 skaermfulde nede paa
   mobil. De to oplagte greb var at forkorte begrundelsen eller at skrue fotoet
   ned. Begge betaler med sidens staerkeste aktiver: begrundelsen er det der goer
   anbefalingen troværdig, og fotoet er hele sidens loefte om at se sengen tage
   form. Og dybden spaerrer ikke for koeb, for bundbjaelken med total og knap er
   altid synlig. Det dybden koster er TILKOEBET.

   Det er altsaa et signalproblem, ikke et afstandsproblem: der blev aldrig givet
   en grund til at rulle videre. Denne linje giver den, og rammesaetter tilvalg
   som at goere sengen faerdig frem for at koebe mere. Moensteret er set live hos
   Parachute, som bruger taeller og synlig rabat i deres bundle-builder.

   BESPARELSEN OPFINDES IKKE HER. Den laeses ud af bundbjaelkens egen metalinje,
   som nw-sg-bar.js allerede har regnet konservativt. Fjerde gang i dette forloeb
   at et haardkodet tal i guiden var drevet fra virkeligheden, saa reglen er:
   ét sted regner, alle andre laeser.

   FEJL FANGET UNDER TEST: foerste version havde dobbelte backslashes i sine
   regulaere udtryk. I GraphQL-blokstrenge er backslash BOGSTAVELIG, saa \\. blev
   til to tegn i filen og udtrykket matchede aldrig. Funktionen koerte fejlfrit
   og returnerede bare altid 0 kr. Enkelt backslash er det rigtige. */
(function(){
  'use strict';

  function antalTilvalg(){
    var n = 0;
    try{
      if(chosen.lagen && chosen.lagen.on){ n++; }
      if(chosen.pb && chosen.pb.qty){ n++; }
      if(chosen.dyne && chosen.dyne.on){ n++; }
      if(chosen.pude && chosen.pude.qty){ n++; }
    }catch(e){}
    return n;
  }

  /* Laeser bundbjaelkens tal i stedet for at regne sit eget. Klassen saettes kun
     naar der faktisk er en rabat at vise. Fejler den, falder vi til 0 og viser
     den neutrale tekst, aldrig et forkert beloeb. */
  function sparFraBjaelken(){
    try{
      var m = document.getElementById('barmeta');
      if(!m || !m.classList.contains('bmeta--spar')){ return 0; }
      var t = m.textContent.replace(/\./g, '').match(/(\d+)\s*kr/);
      return t ? (parseInt(t[1], 10) || 0) : 0;
    }catch(e){ return 0; }
  }

  function kr(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }

  function naevn(){
    var d = [];
    try{
      var t = window.nwSgTilvalg;
      if(!t || t.harLagen(chosen.mat)){ d.push('lagen'); }
      if(!t || t.harPb(chosen.mat)){ d.push('pudebetræk'); }
    }catch(e){ d = ['lagen', 'pudebetræk']; }
    d.push('dyne');
    if(d.length === 1){ return d[0]; }
    return d.slice(0, -1).join(', ') + ' og ' + d[d.length - 1];
  }

  function stil(){
    if(document.getElementById('nw-komplet-css')){ return; }
    var s = document.createElement('style');
    s.id = 'nw-komplet-css';
    s.textContent =
      '#nwsg .nwkomplet{display:flex;align-items:center;justify-content:space-between;gap:12px;width:100%;' +
        'border:1px solid var(--line);background:var(--creamlt);border-radius:6px;padding:13px 15px;' +
        'font-family:inherit;font-size:13.5px;color:var(--ink);cursor:pointer;text-align:left;transition:.18s;line-height:1.35}' +
      '#nwsg .nwkomplet:hover{border-color:var(--sage);background:#fff}' +
      '#nwsg .nwkomplet.spar{border-color:var(--sageLight);background:#fff}' +
      '#nwsg .nwkomplet-t strong{color:var(--sageDark);font-weight:600}' +
      '#nwsg .nwkomplet-p{flex-shrink:0;color:var(--sage);font-size:17px;line-height:1}' +
      '@media(max-width:480px){#nwsg .nwkomplet{font-size:12.5px;padding:11px 13px}}';
    document.head.appendChild(s);
  }

  function tekst(){
    var n = antalTilvalg();
    var spar = sparFraBjaelken();
    if(spar > 0){
      return { html: 'Du sparer <strong>' + kr(spar) + ' kr.</strong> Se flere tilvalg til dit sæt.', spar: true };
    }
    if(n > 0){
      return { html: (n === 1 ? '1 tilvalg' : n + ' tilvalg') + ' valgt. Se resten der gør sengen færdig.', spar: false };
    }
    return { html: 'Gør sengen færdig med ' + naevn() + '.', spar: false };
  }

  function byg(){
    try{
      if(typeof chosen === 'undefined' || !chosen || !chosen.mat){ return; }
      var ctrl = document.querySelector('#nwsg .controls');
      var addons = document.getElementById('addons');
      if(!ctrl || !addons){ return; }
      stil();

      var b = document.getElementById('nwkomplet');
      if(!b){
        /* BEVIDST et button-element og ikke en div. nw-sg-resultat.css sorterer
           trinnene med div:nth-of-type, saa et ikke-div foran dem forskyder
           ingenting. Skiftes dette til en div, gaar raekkefoelgen paa mobil i
           stykker. */
        b = document.createElement('button');
        b.type = 'button';
        b.id = 'nwkomplet';
        b.className = 'nwkomplet';
        b.addEventListener('click', function(){
          try{
            var m = document.getElementById('addons');
            if(!m){ return; }
            var y = m.getBoundingClientRect().top + window.scrollY - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }catch(e){}
        });
        ctrl.insertBefore(b, ctrl.firstChild);
      }

      var t = tekst();
      var ny = '<span class="nwkomplet-t">' + t.html + '</span><span class="nwkomplet-p">›</span>';
      if(b.innerHTML !== ny){ b.innerHTML = ny; }
      b.classList.toggle('spar', t.spar);
    }catch(e){}
  }

  /* Bundbjaelken opdaterer sin metalinje efter renderResult, og kundens klik paa
     et tilvalg gaar gennem refresh(), som gentegner #addons udenom renderResult.
     Derfor lyttes begge steder. Samme faelde som i nw-sg-tekst.js og
     nw-sg-priser.js. */
  var rHooket = false, obs = false;
  function hookResult(){
    if(rHooket || typeof window.renderResult !== 'function'){ return; }
    rHooket = true;
    var f = window.renderResult;
    window.renderResult = function(){ var r = f.apply(this, arguments); byg(); return r; };
  }
  function hookObs(){
    if(obs){ return; }
    var bar = document.getElementById('bar');
    var box = document.getElementById('addons');
    if(!bar || !box){ return; }
    obs = true;
    try{
      new MutationObserver(function(){ byg(); }).observe(bar, { childList: true, subtree: true, characterData: true });
      new MutationObserver(function(){ byg(); }).observe(box, { childList: true, subtree: true });
    }catch(e){}
  }

  function start(){ hookResult(); hookObs(); byg(); }

  start();
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', start); }
  window.addEventListener('load', start);
  setTimeout(start, 1500);
  setTimeout(start, 3500);
})();